
/**
 * Extends a loan for a specific item.
 * @param {string} API_BASE Base URL of the API
 * @param {string} token JWT authorization token
 * @param {string} itemId The ID of the item (book) currently on loan
 */
async function extendLoan(API_BASE, token, itemId) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/loans/${itemId}/prolongation`, {
        method: "PUT",
        headers,
    });

    if (!response.ok) {
        throw new Error("Erreur lors de la prolongation du prêt: " + (await response.text()));
    }

    const data = await response.json();
    //console.log("Prêt prolongé avec succès:", data);

    return data;
}

export default extendLoan;
